import { environmentSchema } from '@gonfalon/environments/environmentSchema';
import { z } from 'zod';

export const projectSchema = z.object({
  _id: z.string(),
  _links: z.record(z.string(), z.any()),
  defaultClientSideAvailability: z.object({
    usingEnvironmentId: z.boolean(),
    usingMobileKey: z.boolean(),
  }),
  defaultReleasePipelineKey: z.string().optional(),
  // Tolerate a legacy (V3) `environments` array or `null` here instead of failing the whole
  // project: a stale response in the shared project query cache must not crash every
  // `useProjectContext` consumer, and nothing reads environments off the project context.
  environments: z
    .object({ items: z.array(environmentSchema) })
    .optional()
    .catch(undefined),
  includeInSnippetByDefault: z.boolean(),
  key: z.string(),
  name: z.string(),
  requireViewAssociationForNewFlags: z.boolean().optional(),
  requireViewAssociationForNewSegments: z.boolean().optional(),
  requireTeamMaintainerForNewFlags: z.boolean().optional(),
  tags: z.array(z.string()),
});
